import React from 'react';
import { DemographicTypes } from 'store/preRegistration/types';
import { MuiBox } from 'theme/material-ui';
import { PersonalInfoInputLabel, PreRegInputBox, PersonalInfoFormControl } from './styled';
import Config from 'react-native-config';

const ALLOW_UPDATE = Config.PRE_REG_ALLOW_SAVE_PATIENT_DATA === 'enabled';

export function MaritalStatus({
  demographicTypes,
  value,
  handleMaritalStatusChange
}: {
  demographicTypes: DemographicTypes;
  value?: string;
  handleMaritalStatusChange: (value: string) => void;
}) {
  const unOrderedMaritalStatus = [...demographicTypes.maritalStatus];
  const orderedMaritalStatus = unOrderedMaritalStatus.sort((a, b) => (a.key < b.key ? -1 : 1));

  const displayMaritalStatus = demographicTypes.maritalStatus.find(item => item.value === value);

  return (
    <MuiBox data-testid="marital-status">
      <PersonalInfoInputLabel required={!!ALLOW_UPDATE}>Marital Status</PersonalInfoInputLabel>
      <PersonalInfoFormControl>
        <PreRegInputBox
          disabled={!ALLOW_UPDATE}
          as={ALLOW_UPDATE ? 'select' : ''}
          type="martialStatus"
          name="maritalStatus"
          option={demographicTypes?.maritalStatus}
          defaultValue={displayMaritalStatus?.key || 'Unknown Marital Status'}
          onChange={event => {
            const key = event.target.value;
            const obj = demographicTypes.maritalStatus.find(item => item.key === key);
            handleMaritalStatusChange(obj?.value);
          }}
        >
          {ALLOW_UPDATE
            ? orderedMaritalStatus.map(maritalStatus => (
                <option key={maritalStatus.key}>{maritalStatus.key}</option>
              ))
            : null}
        </PreRegInputBox>
      </PersonalInfoFormControl>
    </MuiBox>
  );
}
